import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from "react-multi-date-picker";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
// import Packing_Checklist from '../../../modal/Production_Management/Manage_Packing/Packing_Checklist';
import Packing_Checklist from '../../../modal/Production_Management/Manage_Packing/Packing_Checklist';
import Packing_Checklist_Cat from '../../../modal/Production_Management/Manage_Packing/Packing_Checklist_Cat';
import Packing_Checklist_Corp from '../../../modal/Production_Management/Manage_Packing/Packing_Checklist_Corp';
import Dispatch_Product from '../../../modal/Production_Management/Manage_Packing/Dispatch_Product';
import Dispatch_Product_Cat from '../../../modal/Production_Management/Manage_Packing/Dispatch_Product_Cat';
import Dispatch_Product_Corp from '../../../modal/Production_Management/Manage_Packing/Dispatch_Product_Corp';
import { Row, Col, Tab, Nav } from "react-bootstrap";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const Manage_Packing = () => {

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state?.toastMessage) {
            const type = location.state.toastType === 'success' ? toast.success : toast.error;
            type(location.state.toastMessage);
            navigate(location.pathname, { replace: true });
        }
    }, [location.state]);

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const [selectedPackingData, setSelectedPackingData] = useState(null);
    const today = dayjs().format('YYYY-MM-DD');
    const [selectedDate, setSelectedDate] = useState(today);

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    const fetchData = (filter = {}) => {
        const datePayload = getDateFilterPayload(); // get date filters

        const params = {
            ...filter,
            page,
            per_page: perPage,
            search: searchTerm,
            branch_id,
            ...datePayload, // add date filters
        };

        axios.get(`${baseURL}/subscriber-packing-list`, { params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.pagination.last_page);
                setTotslEntries(response.data.pagination.total);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setHasFetched(true);
            });
    };


    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage, selectedDate]);

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const tableRef = useRef(null);
    const [key, setKey] = useState('subscription_packing');

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    const [filterOpen, setFilterOpen] = useState(false);

    const onClose = () => {
        setFilterOpen(false);
    };

    const getDateFilterPayload = () => {
        let payload = {};

        switch (date_fil_selt_value) {
            case "today":
                payload.date = dayjs(today_fil_value).format('YYYY-MM-DD');
                break;
            case "this_week":
                payload.start_date = dayjs(week_stdt_fil_value).format('YYYY-MM-DD');
                payload.end_date = dayjs(week_eddt_fil_value).format('YYYY-MM-DD');
                break;
            case "this_month":
                payload.month = dayjs(month_fil_value).format('M'); // 1-12
                payload.year = dayjs(month_fil_value).format('YYYY');
                break;
            case "custom":
                payload.start_date = dayjs(custom_stdt_fil_value).format('YYYY-MM-DD');
                payload.end_date = dayjs(custom_eddt_fil_value).format('YYYY-MM-DD');
                break;
            case "all":
            default:
                break;
        }

        return payload;
    };


    const handleModalToggleChecklist = async (data) => {
        if (!data?.sno) return;

        const BaseUrl = process.env.REACT_APP_API_BASE_URL;

        try {
            const response = await axios.get(
                `${BaseUrl}/subscriber-packing-item-view/${data.sno}`
            );

            if (response.data?.data) {
                setSelectedPackingData(response.data.data);  // <-- Pass correct API data
                setModalType("Packing_Checklist");
                setOpen(true);
            }
        } catch (error) {
            console.error("Error fetching packing details:", error);
            toast.error("Failed to load packing checklist details.");
        }
    };


    const handleModalToggleDispatch = () => {
        setModalType("Dispatch_Product");
        setOpen(true);
    };



    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(new Date());
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(new Date());
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custum Date" }
    ];



    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Packing</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Production Management</li>
                    </ol>
                </div>
                {open && modalType === "Packing_Checklist" && (
                    <Packing_Checklist
                        show={open}
                        onClose={() => setOpen(false)}
                        packingData={selectedPackingData}
                    />

                )}
                {open && modalType === "Packing_Checklist_Cat" && (
                    <Packing_Checklist_Cat show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "Packing_Checklist_Corp" && (
                    <Packing_Checklist_Corp show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "Dispatch_Product" && (
                    <Dispatch_Product show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "Dispatch_Product_Cat" && (
                    <Dispatch_Product_Cat show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "Dispatch_Product_Corp" && (
                    <Dispatch_Product_Corp show={open} onClose={() => setOpen(false)} />
                )}
                <div className='d-flex align-items-center justify-content-center flex-row gap-2'>
                    <label className='fs-5 text-danger font-w600'>
                        {new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-')}
                    </label>
                    <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                        <span className='me-2'><i class="fa-solid fa-filter fs-8"></i></span>
                        <span className=''>Filter</span>
                    </Link>
                </div>
            </div>
            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="subscription_packing">
                                    <i class="fa-solid fa-money-bill-trend-up me-2"></i>
                                    <label className="fs-6">
                                        Subscription
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-packing-catering">
                                    <i class="fa-solid fa-layer-group me-2"></i>
                                    <label className="fs-6">
                                        Catering Order
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-packing-corporate">
                                    <i class="fa-solid fa-hotel me-2"></i>
                                    <label className="fs-6">
                                        Corporate Order
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content className="pt-4">

                            <Tab.Pane eventKey="subscription_packing">
                                <Row>
                                    <Col xl={12}>
                                        <div className="table-container">

                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                {/* Left: Show entries dropdown */}
                                                <div>
                                                    <label className="me-2">Show</label>
                                                    <select
                                                        className="form-select d-inline w-auto"
                                                        style={{ fontSize: '0.85rem', height: '30px' }}
                                                        value={perPage}
                                                        onChange={(e) => {
                                                            setPerPage(Number(e.target.value));
                                                            setPage(1); // Reset to first page
                                                        }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={25}>25</option>
                                                        <option value={50}>50</option>
                                                        <option value={100}>100</option>
                                                    </select>
                                                </div>

                                                {/* Right: Search input */}
                                                <div>
                                                    <input
                                                        type="text"
                                                        style={{ fontSize: '0.85rem', height: '40px' }}
                                                        placeholder="Search..."
                                                        className="form-control"
                                                        value={searchTerm}
                                                        onChange={(e) => {
                                                            setSearchTerm(e.target.value);
                                                            setPage(1); // Reset page on new search
                                                        }}
                                                    />
                                                </div>
                                            </div>


                                            <table
                                                className="item_data_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}>
                                                <thead>
                                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                        <th className="min-w-50px text-start">Date</th>
                                                        <th className="min-w-100px text-start">Product Name</th>
                                                        <th className="min-w-100px text-center">Box Count</th>
                                                        <th className="min-w-80px text-center">Packing / Total Count</th>
                                                        <th className="min-w-80px">Packing Status</th>
                                                        <th className="min-w-80px text-end">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-600 fw-semibold fs-7">
                                                    {datas.length === 0 && hasFetched ? (
                                                        <tr>
                                                            <td colSpan="9" className="text-center text-muted py-2">
                                                                No data available
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        datas.map((data, index) => (
                                                            <tr key={index}>
                                                                {/* Product / Category */}
                                                                <td className='text-start text-black'>
                                                                    {new Date(data.packing_date).toLocaleDateString('en-GB', {
                                                                        day: '2-digit',
                                                                        month: 'short',
                                                                        year: 'numeric'
                                                                    })}
                                                                </td>


                                                                <td>

                                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                                        <LightGallery
                                                                            onInit={onInit}
                                                                            speed={500}
                                                                            plugins={[lgThumbnail, lgZoom]}
                                                                        >
                                                                            <div data-src={data.product_image} className="border rounded px-1 py-0">
                                                                                <img
                                                                                    src={data.product_image}
                                                                                    alt={data.product_name}
                                                                                    className="cursor-pointer w-50px h-50px"
                                                                                />
                                                                            </div>
                                                                        </LightGallery>
                                                                        <div className="d-flex flex-column align-items-start">
                                                                            <label className="text-black font-w400 fs-7">{data.product_name}</label>
                                                                        </div>
                                                                    </div>
                                                                </td>

                                                                <td className='text-center'>
                                                                    <Badge bg="warning" className="text-black rounded-circle font-w500 fs-7">
                                                                        {(String(data.subscriber_count ?? 0)).padStart(2, '0')}
                                                                    </Badge>
                                                                </td>


                                                                <td className='text-end'>
                                                                    <div className="d-flex flex-row align-items-center justify-content-center gap-1">
                                                                        <label className="text-danger rounded border border-danger py-1 px-2 font-w700 fs-7">
                                                                            {(String(data.packed_item_count ?? 0)).padStart(2, '0')}
                                                                            {/* {data.packed_item_count ?? 0} */}
                                                                        </label>
                                                                        <label className="text-black font-w400 fs-7">|</label>
                                                                        <label className="text-primary rounded border border-primary py-1 px-2 font-w700 fs-7">
                                                                            {/* {data.total_packing_count ?? 0} */}
                                                                            {(String(data.total_packing_count ?? 0)).padStart(2, '0')}
                                                                        </label>
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    {data.packing_status == 0 && (
                                                                        <Badge bg="info" className="text-white rounded font-w500 fs-7">Yet to Pack</Badge>
                                                                    )}
                                                                    {data.packing_status == 1 && (
                                                                        <Badge bg="danger" className="text-white rounded font-w500 fs-7">Packing</Badge>
                                                                    )}
                                                                    {data.packing_status === 2 && (
                                                                        <Badge bg="success" className="text-white rounded font-w500 fs-7">Packed</Badge>
                                                                    )}
                                                                    {data.packing_status === 3 && (
                                                                        <div className="d-flex flex-column align-items-start">
                                                                            <Badge bg="primary" className="text-white rounded font-w500 fs-7">Dispatched</Badge>
                                                                            <OverlayTrigger
                                                                                trigger="hover"
                                                                                placement="bottom"
                                                                                overlay={
                                                                                    <Tooltip className="toltip-popover">
                                                                                        <span className="fs-8 text-white fw-semibold">Dispatched Time</span>
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <label className="text-danger font-w500 fs-7">
                                                                                    <span>{data.dispatched_date ? dayjs(data.dispatched_date).format('DD-MMM-YYYY hh.mm a') : ''}</span>
                                                                                </label>
                                                                            </OverlayTrigger>
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                {/* Actions */}
                                                                <td className="text-end">
                                                                    <OverlayTrigger
                                                                        trigger={['hover', 'focus']}
                                                                        placement="bottom"
                                                                        overlay={
                                                                            <Tooltip className="toltip-popover">
                                                                                <span className="fs-8 text-white fw-semibold">View</span>
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <Link to={`/view-subscription-packing?sno=${data.sno}`}>
                                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1">
                                                                                <i className="fa-solid fa-eye fs-6 mt-1"></i>
                                                                            </Button>
                                                                        </Link>
                                                                    </OverlayTrigger>

                                                                    {[0, 1].includes(data.packing_status) && (
                                                                        <OverlayTrigger
                                                                            trigger={['hover', 'focus']}
                                                                            placement="bottom"
                                                                            overlay={
                                                                                <Tooltip className="toltip-popover">
                                                                                    <span className="fs-8 text-white fw-semibold">Packing Checklist</span>
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <Button
                                                                                variant="primary tp-btn-light px-2 py-1 me-1"
                                                                                onClick={() => handleModalToggleChecklist(data)}
                                                                            >
                                                                                <i className="fa-solid fa-box-archive fs-6 mt-1"></i>
                                                                            </Button>
                                                                        </OverlayTrigger>
                                                                    )}

                                                                    {data.packing_status === 2 && (
                                                                        <OverlayTrigger
                                                                            trigger={['hover', 'focus']}
                                                                            placement="bottom"
                                                                            overlay={
                                                                                <Tooltip className="toltip-popover">
                                                                                    <span className="fs-8 text-white fw-semibold">Move to Delivery</span>
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <Link to={`/manage-packing-delivery?data=${data.sno}`}>
                                                                                <Button
                                                                                    variant="primary tp-btn-light px-2 py-1 me-1"
                                                                                    onClick={handleModalToggleDispatch}
                                                                                >
                                                                                    <i className="fa-solid fa-truck-arrow-right fs-6 mt-1"></i>
                                                                                </Button>
                                                                            </Link>
                                                                        </OverlayTrigger>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>

                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                {/* Bottom left: Showing x to y of z entries */}
                                                <div>
                                                    {datas.length > 0 ? (
                                                        <span className="text-muted">
                                                            Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                                        </span>
                                                    ) : (
                                                        <span className="text-muted">
                                                            Showing 0 to 0 of 0 entries
                                                        </span>
                                                    )}
                                                </div>

                                                {/* Bottom right: Pagination */}
                                                <nav>
                                                    <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                        {/* Previous Button */}
                                                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                                Previous
                                                            </button>
                                                        </li>

                                                        {/* First Page */}
                                                        <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                                1
                                                            </button>
                                                        </li>

                                                        {/* Left Ellipsis */}
                                                        {page > 4 && (
                                                            <li className="page-item disabled">
                                                                <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                            </li>
                                                        )}

                                                        {/* Pages Around Current */}
                                                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                            .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                                            .map(p => (
                                                                <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                                        {p}
                                                                    </button>
                                                                </li>
                                                            ))}

                                                        {/* Right Ellipsis */}
                                                        {page < totalPages - 3 && (
                                                            <li className="page-item disabled">
                                                                <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                            </li>
                                                        )}

                                                        {/* Last Page */}
                                                        {totalPages > 1 && (
                                                            <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                                    {totalPages}
                                                                </button>
                                                            </li>
                                                        )}

                                                        {/* Next Button */}
                                                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                                Next
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Tab.Pane>

                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>

            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Manage Wastage Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            // value={"05/18/2020 02:20:36 PM"}
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY"
                                            // format="DD/MM/YYYY hh:mm:ss A"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1">
                        {/* <Button className="me-2 btn-sm" variant="secondary" onClick={onClose}>
                            <span className='font-w400'>Reset</span>
                        </Button> */}
                        <Button
                            className="me-2 btn-sm"
                            variant="secondary"
                            onClick={() => {
                                setDateFilSeltValue("all");
                                setTodayFilValue(new Date());
                                setWeekSTDTFilValue(new Date());
                                setWeekEDDTFilValue(new Date());
                                setMonthFilValue(new Date());
                                setCustomSTDTFilValue(new Date());
                                setCustomEDDTFilValue(new Date());
                                setPage(1);
                                fetchData();
                                setFilterOpen(false);
                            }}
                        >
                            <span className='font-w400'>Reset</span>
                        </Button>

                        {/* <Button className="me-2 btn-sm" variant="primary" onClick={onClose}>
                            <span className='font-w400'>Go</span>
                        </Button> */}
                        <Button
                            className="me-2 btn-sm"
                            variant="primary"
                            onClick={() => {
                                setPage(1); // reset to first page
                                fetchData(); // fetch with selected filters
                                setFilterOpen(false); // close drawer
                            }}
                        >
                            <span className='font-w400'>Go</span>
                        </Button>

                    </div>
                </div>
            </Drawer>
        </>
    )


}
export default Manage_Packing;